package app.bloomey.web.modules.feedback

import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.data.models.PageResponse
import app.bloomey.web.modules.feedback.model.Feedback

object FeedbackContract {
    data class State(
        val page: Int = 0,
        val itemsState: UiState<PageResponse<List<Feedback>>> = UiState.Initial,
    )

    sealed interface Inputs {
        data class GetPage(val page: Int, val size: Int, val query: String) : Inputs
    }

    sealed interface Events
}
